import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    verifyDate(evt) {
        evt.preventDefault()

        const date = this.element.querySelector("#dob").value
        console.log(date)
        if (date === ""){
            return
        }
        this.element.querySelector("form").requestSubmit();
    }

    toggleDisabled(evt) {
        evt.preventDefault()
        const btn = document.querySelector('#formSubmit')
        btn.disabled = !btn.disabled
    }
}
